module.exports = __webpack_public_path__ + "img/cpos-light.f904d0a9.webp";